"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DropDownComponent = function DropDownComponent(props) {
  var placement = props.placement,
      children = props.children,
      menus = props.menus,
      className = props.className,
      triggerEvent = props.triggerEvent,
      getPopupContainer = props.getPopupContainer,
      onVisibleChange = props.onVisibleChange,
      isVisible = props.isVisible;
  return /*#__PURE__*/_react["default"].createElement(_antd.Dropdown, _extends({
    overlayClassName: "dropdown-optn ".concat(className ? className : ""),
    overlay: menus || "",
    placement: placement || "bottomRight",
    trigger: triggerEvent || "click",
    getPopupContainer: getPopupContainer,
    onVisibleChange: onVisibleChange ? function () {
      return onVisibleChange();
    } : function () {
      "";
    },
    visible: isVisible
  }, props), children);
};

var _default = DropDownComponent;
exports["default"] = _default;